import app from 'flarum/forum/app';
import { onGovernors } from '../../common/community';

/**
 * "About this ranking" at the top of the theme's right sidebar on the governors page.
 * Plain markup (outside the redraw cycle): the ranking measure is loaded, then drawn once.
 */
let meta = null;
let loading = null;
function load() {
  if (meta) return Promise.resolve(meta);
  loading ??= app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/voucha-community/governors',
    errorHandler: () => {}
  }).then(r => meta = r.ranking).finally(() => loading = null);
  return loading;
}
export function rankingText(r) {
  const w = r && r.weights || {};
  if (r && r.key === 'composite') {
    // the wording follows the live weights, so it stays right if they're changed in admin
    const parts = [];
    if (w.igr_pc) parts.push('IGR per person (' + w.igr_pc + '%)');
    if (w.igr) parts.push('total IGR (' + w.igr + '%)');
    if (w.igr_faac) parts.push('financial independence from FAAC (' + w.igr_faac + '%)');
    if (w.debt_igr) parts.push('debt relative to IGR (' + w.debt_igr + '%)');
    if (w.population) parts.push('population (' + w.population + '%)');
    if (w.gdp) parts.push('GDP (' + w.gdp + '%)');
    if (w.gdp_faac) parts.push('GDP relative to FAAC (' + w.gdp_faac + '%)');
    const words = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven'];
    const list = parts.length > 1 ? parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1] : parts[0];
    return 'States are ranked out of 100 using ' + (words[parts.length] || parts.length) + ' indicator' + (parts.length === 1 ? '' : 's') + ': ' + list + '. Scores reflect performance compared to other states.';
  }
  return 'For now, governors are ranked by their state\u2019s population (NPC 2022 estimate), until revenue, allocation and debt figures are in the Data Hub.';
}
export function ensureRankingAbout(tries = 0) {
  const existing = document.querySelector('.VGovAbout-slot');
  if (!onGovernors()) {
    if (existing) existing.remove();
    return;
  }
  const aside = document.querySelector('.Voucha-rightSidebar');
  if (!aside) {
    if (tries < 25) setTimeout(() => ensureRankingAbout(tries + 1), 80);
    return;
  }
  if (existing && existing.parentNode === aside) return;
  const slot = document.createElement('div');
  slot.className = 'VGovAbout-slot';
  aside.insertBefore(slot, aside.firstChild);
  load().then(r => {
    if (!slot.isConnected) return;
    m.render(slot, m("div", {
      className: "VGovAbout"
    }, m("h3", null, m("i", {
      className: "fas fa-chart-bar",
      "aria-hidden": "true"
    }), " About this ranking"), m("p", null, rankingText(r)), r && r.key === 'composite' ? m("p", {
      className: "VGovAbout-source"
    }, "Sources:", ' ', [['NBS', 'state_igr', 'State IGR (NBS)'], ['OAGF', 'faac_state', 'FAAC allocations (OAGF)'], ['DMO', 'state_debt_domestic', 'State debt (DMO)'], ['NPC', 'population_2022', 'Population (NPC)']].map(([label, key, title], i) => [i ? ', ' : '', m("a", {
      href: app.route('voucha-datahub.dataset', {
        key
      }),
      title: title,
      onclick: e => {
        if (e.ctrlKey || e.metaKey) return;
        e.preventDefault();
        m.route.set(app.route('voucha-datahub.dataset', {
          key
        }));
      }
    }, label)])) : r && r.source ? m("p", {
      className: "VGovAbout-source"
    }, "Source: ", r.source) : null));
  }).catch(() => {});
}
flarum.reg.add('voucha-community', 'forum/components/RankingAbout', { rankingText: rankingText,ensureRankingAbout: ensureRankingAbout, });